"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitleString = exports.getPriceWithLabel = exports.getFormattedTimePeriod = exports.getFormattedTime = exports.getFormattedPriceWithEnding = exports.getFormattedPrice = exports.getFormattedOrganizationNumber = exports.getFormattedDateTimePretty = exports.getFormattedDate = exports.getFormattedCardNumber = void 0;
var _dates = require("./dates");
/**
 * PRICES
 */
const getFormattedPrice = (price, decimals, roundDown) => {
  if (isNaN(price)) {
    return price;
  }
  if (price === undefined || price === null) {
    return '';
  }
  if (roundDown) {
    price = Math.floor(price);
  }
  const formatted = new Intl.NumberFormat(['no-NO', 'nb-NO'], {
    style: 'decimal',
    useGrouping: true,
    currency: 'NOK',
    maximumFractionDigits: decimals ? decimals : 0,
    minimumFractionDigits: decimals ? decimals : 0
  }).format(price);
  return decimals ? formatted : formatted.replace(/,/g, '.');
};
exports.getFormattedPrice = getFormattedPrice;
const getPriceWithLabel = (clarificationInAdvance, pricing) => {
  return `${getPriceLabel(clarificationInAdvance)} ${getFormattedPriceWithEnding(getPrice(clarificationInAdvance, pricing))}`;
};
exports.getPriceWithLabel = getPriceWithLabel;
const getPriceLabel = clarificationInAdvance => clarificationInAdvance ? 'Prisantydning' : 'Fastpris';
const getPrice = (clarificationInAdvance, pricing) => clarificationInAdvance ? pricing.askingPrice : pricing.fixedPrice;
const getFormattedPriceWithEnding = (price, decimals) => {
  if (price === undefined || price === null) {
    return 'Ikke angitt';
  }
  const formattedPrice = getFormattedPrice(price, decimals);
  return formattedPrice + ' kr';
};

/**
 * DATES
 */
exports.getFormattedPriceWithEnding = getFormattedPriceWithEnding;
const getFormattedDate = (date, opt) => {
  const options = opt || {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  };
  return new Intl.DateTimeFormat(['no-NO', 'nb-NO', 'nn-NO', 'de-DE'], options).format(new Date(date));
};
exports.getFormattedDate = getFormattedDate;
const getFormattedTime = date => {
  const parsedDate = new Date(date);
  return (parsedDate.getHours() < 10 ? '0' : '') + parsedDate.getHours() + ':' + (parsedDate.getMinutes() < 10 ? '0' : '') + parsedDate.getMinutes();
};
exports.getFormattedTime = getFormattedTime;
const getFormattedDateTimePretty = (date, opt = _dates.ddmmyyyy) => {
  if (!date) return '';
  return `${getFormattedDate(date, opt)} kl ${getFormattedTime(date)}`;
};

/**
 * OTHERS
 */
exports.getFormattedDateTimePretty = getFormattedDateTimePretty;
const getTitleString = text => {
  if (!text) return '';
  text = text.toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};
exports.getTitleString = getTitleString;
const getFormattedCardNumber = cardNumber => {
  if (!cardNumber) return '';
  cardNumber = cardNumber.replace(/\s/g, '');
  let formatted = '';
  for (var i = 0; i < cardNumber.length; i++) {
    if (i % 4 === 0 && i > 0) formatted = formatted.concat(' ');
    formatted = formatted.concat(cardNumber[i]);
  }
  return formatted;
};
exports.getFormattedCardNumber = getFormattedCardNumber;
const getFormattedOrganizationNumber = organizationNumber => {
  let org = String(organizationNumber);
  if (!org) return '';
  org = org.replace(/\s/g, '');
  return org.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
exports.getFormattedOrganizationNumber = getFormattedOrganizationNumber;
const getFormattedTimePeriod = (startDate, endDate) => {
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;
  if (!start && !end) return '';
  if (start && end && (0, _dates.datesAreOnSameDay)(start, end)) return `${getFormattedDateTimePretty(start)}-${getFormattedTime(end)}`;
  return `${start ? getFormattedDateTimePretty(start) + ' ' : ''}-${end ? ' ' + getFormattedDateTimePretty(end) : ''}`;
};
exports.getFormattedTimePeriod = getFormattedTimePeriod;